import { render, staticRenderFns } from "./BannerConfig.vue?vue&type=template&id=311e023c"
import script from "./BannerConfig.vue?vue&type=script&lang=js"
export * from "./BannerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports